import { RouterProvider } from 'react-router-dom'
import { router } from '@/_app/routes'
import ApolloProvider from '@/shared/ui/providers/ApolloProvider'
import AuthSessionProvider from '@/shared/ui/providers/AuthSessionProvider'
import { UnleashProvider, UnleashContextSync } from '@/shared/ui/providers/UnleashProvider'
import { LinguiProvider } from '@/shared/ui/providers/LinguiProvider'
import MuiThemeProvider from '@/shared/ui/providers/MuiThemeProvider'
import SnackbarProvider from '@/shared/ui/providers/SnackbarProvider'
import SWRConfigProvider from '@/shared/ui/providers/SWRConfigProvider'
import { I18nextProvider } from 'react-i18next'
import i18n from '@/lib/i18n/i18n'

function App() {
  return (
    <UnleashProvider>
      <I18nextProvider i18n={i18n}>
        <LinguiProvider>
          <MuiThemeProvider>
            <SnackbarProvider maxSnack={3}>
              <SWRConfigProvider>
                <AuthSessionProvider>
                  <UnleashContextSync />
                  <ApolloProvider>
                    <RouterProvider router={router} />
                  </ApolloProvider>
                </AuthSessionProvider>
              </SWRConfigProvider>
            </SnackbarProvider>
          </MuiThemeProvider>
        </LinguiProvider>
      </I18nextProvider>
    </UnleashProvider>
  )
}

export default App
